import { useEffect, useState } from "react";
import { slugify } from "../../funcionesDatos/Textos";

function ModalWhatsapp({ proveedor, servicio, adminNombre, onCerrar }) {
    const [urlServicio, setUrlServicio] = useState("");

    useEffect(() => {
        if (servicio?.nombre && servicio?.idServicio) {
            slugify(servicio.nombre).then(slug => {
                setUrlServicio(`https://www.zervicy.com/servicio/${slug || "servicio"}-${servicio.idServicio}`);
            });
        }
    }, [servicio]);

    const estado    = servicio?.estado || "";
    const nombreP   = [proveedor?.nombre, proveedor?.apellido].filter(v => v && v !== "NA").join(" ") || proveedor?.username || "";
    const tel       = (proveedor?.telefono || "").replace(/\D/g, "");
    const telInt    = tel.startsWith("57") ? tel : `57${tel}`;
    const urlPerfil = `https://www.zervicy.com/${proveedor?.username}`;
    const urlRef    = `https://www.zervicy.com/${proveedor?.username}/te-invito-a-zervicy`;
    const firma     = adminNombre ? `\n\nHola, soy ${adminNombre} de Zervicy.` : "";

    const msgFelicitacion = [
        `Hola ${nombreP}!${firma}`,
        "",
        `Te escribimos para contarte que tu servicio "${servicio?.nombre || ""}" ha sido aprobado.`,
        "",
        "Aqui puedes verlo publicado:",
        urlServicio,
        "",
        "Tambien puedes entrar a tus servicios y editarlo cuando quieras.",
        "",
        "---",
        "",
        "En Zervicy todos los socios tienen su propia URL para compartir en sus redes sociales:",
        urlPerfil,
        "",
        "---",
        "",
        "Y si quieres referir a otros socios, companeros de trabajo o amigos, este es tu enlace de referidos (pronto tendremos promociones y mas con tus referencias):",
        urlRef,
        "",
        "Felicitaciones y bienvenido al equipo!",
    ].join("\n");

    const msgBorrador = [
        `Hola ${nombreP}!${firma}`,
        "",
        "Notamos que tienes un servicio pendiente de publicar.",
        "",
        "Queremos ayudarte a terminarlo gratis y sin complicaciones. Solo sigue este enlace, seras dirigido a nuestro WhatsApp de soporte, cuentanos tu usuario o correo registrado y uno de nosotros te guia paso a paso hasta que tu servicio este publicado:",
        "",
        "https://www.zervicy.com/soporte-wapp",
        "",
        "Te esperamos!",
    ].join("\n");

    const msgLlamada = [
        `Hola ${nombreP}!${firma}`,
        "",
        "Hace un momento te llamamos para ayudarte a publicar tu servicio en Zervicy, pero no pudimos comunicarnos contigo.",
        "",
        "Si tienes un momento libre, por favor confirmame y te llamo de inmediato para guiarte paso a paso. No te tomara mucho tiempo!",
    ].join("\n");

    const msgVerificar = [
        `Hola ${nombreP}!${firma}`,
        "",
        "Para verificar tu identidad, sigue estos pasos:",
        "",
        "1. Abre la aplicacion.",
        "2. Toca Perfil (icono en la esquina inferior derecha).",
        `3. En la seccion "Modo: Comprador", toca el interruptor para cambiar al Modo vendedor.`,
        "4. Selecciona Mi perfil.",
        "5. Pulsa Verificar mi cuenta.",
        "    - Toma una foto de tu cedula.",
        "    - Tómate una selfie.",
        "",
        "6. Completa tu informacion personal.",
        "En la seccion Informacion personal, diligencia todos los campos:",
        "",
        "- Nombre",
        "- Apellido",
        "- Pais",
        "- Ciudad",
        "- Telefono",
        "- Tipo y numero de identificacion",
        "",
        "Cuando termines, pulsa Guardar informacion y luego Confirmar informacion personal.",
        "",
        "Listo! Tu identidad quedara completamente verificada y ya podremos publicar tu primer servicio en Zervicy.",
        "",
        "Tip importante: Si lo deseas, aprovecha este momento para completar tambien tu Informacion bancaria. Alli podras registrar la cuenta bancaria o billetera digital donde deseas recibir los pagos por los servicios que vendas en Zervicy. De esta forma, cuando recibas tu primera venta, ya tendras todo configurado para recibir tu dinero sin demoras.",
    ].join("\n");

    const abrir = (msg) => {
        const url = msg
            ? `https://wa.me/${telInt}?text=${encodeURIComponent(msg)}`
            : `https://wa.me/${telInt}`;
        window.open(url, "_blank", "noopener,noreferrer");
        onCerrar();
    };

    const msgDesaprobado = [
        `Hola ${nombreP}!${firma}`,
        "",
        `Te informamos que tu servicio "${servicio?.nombre || ""}" fue desaprobado.`,
        ...(servicio?.mensajeRevision ? [`\nMotivo: ${servicio.mensajeRevision}`, ""] : [""]),
        "Queremos ayudarte a corregirlo y aprobarlo de nuevo. Escribenos o llamanos y con gusto te explicamos que debes ajustar.",
        "",
        "https://www.zervicy.com/soporte-wapp",
    ].join("\n");

    const esAprobado    = estado === "Aprobado";
    const esBorrador    = estado === "Borrador";
    const esDesaprobado = estado === "Desaprobado";

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ background: "rgba(var(--negro-rgb), 0.45)", zIndex: 1055 }}
            onClick={e => { if (e.target === e.currentTarget) onCerrar(); }}
        >
            <div
                className="bg-white rounded-4 shadow-lg p-4"
                style={{ maxWidth: 460, width: "92%", position: "relative" }}
            >
                <div className="d-flex align-items-center gap-2 mb-1">
                    <span style={{ fontSize: 22, color: "var(--verde-whatsapp)" }}>
                        <i className="bi bi-whatsapp"></i>
                    </span>
                    <h6 className="mb-0 fw-bold">Contactar por WhatsApp</h6>
                    <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={onCerrar}
                        aria-label="Cerrar"
                    />
                </div>
                <p className="text-muted small mb-3">
                    Que mensaje quieres enviarle a <strong>{nombreP}</strong>?
                </p>

                <OpcionBtn
                    icono="bi-chat"
                    titulo="Abrir chat sin texto"
                    desc="Abre WhatsApp directamente sin mensaje predefinido"
                    onClick={() => abrir(null)}
                />

                {esAprobado && (
                    <OpcionBtn
                        icono="bi-send-check"
                        titulo="Enviar mensaje de felicitacion"
                        desc="Incluye el link del servicio, URL de perfil y enlace de referidos"
                        onClick={() => abrir(msgFelicitacion)}
                        disabled={!urlServicio}
                        bg="var(--verde-fondo-muy-suave-2)"
                        mt
                    />
                )}

                {esDesaprobado && (
                    <OpcionBtn
                        icono="bi-exclamation-circle"
                        titulo="Servicio desaprobado — queremos ayudarte"
                        desc="Le informas que su servicio fue desaprobado y que lo pueden ayudar a corregirlo"
                        onClick={() => abrir(msgDesaprobado)}
                        bg="var(--naranja-fondo-muy-suave)"
                        mt
                    />
                )}

                {esBorrador && (
                    <>
                        <OpcionBtn
                            icono="bi-telephone-x"
                            titulo="Te llamamos pero no contestaste"
                            desc="Le avisas que lo llamaste y le pides que confirme para devolverle la llamada"
                            onClick={() => abrir(msgLlamada)}
                            mt
                        />
                        <OpcionBtn
                            icono="bi-megaphone"
                            titulo="Recordar publicar servicio"
                            desc="Le explicas como recibir ayuda para publicar su servicio"
                            onClick={() => abrir(msgBorrador)}
                            mt
                        />
                        <OpcionBtn
                            icono="bi-clipboard-check"
                            titulo="Guia para verificar cuenta"
                            desc="Le envias los pasos para verificar su identidad y completar su perfil"
                            onClick={() => abrir(msgVerificar)}
                            mt
                        />
                    </>
                )}

                {esAprobado && !urlServicio && (
                    <p className="text-muted small mt-2 mb-0 text-center">
                        <span className="spinner-border spinner-border-sm me-1" style={{ width: 12, height: 12 }}></span>
                        Generando enlace del servicio...
                    </p>
                )}
            </div>
        </div>
    );
}

function OpcionBtn({ icono, titulo, desc, onClick, disabled, bg = "var(--gris-muy-claro)", mt = false }) {
    // El fondo (bg) siempre es un pastel claro fijo (no se adapta a modo oscuro a propósito, para
    // mantener el significado del color — verde=aprobado, naranja=desaprobado, etc.), así que el
    // texto y el ícono también van fijos en tonos oscuros, en vez de heredar clases de Bootstrap
    // (text-secondary, text-muted) que sí cambian con el tema y quedarían ilegibles sobre el pastel.
    return (
        <button
            type="button"
            className={`btn w-100 text-start rounded-3 border p-3${mt ? " mt-2" : ""}`}
            style={{ background: bg }}
            onClick={onClick}
            disabled={disabled}
        >
            <div className="d-flex align-items-center gap-3">
                <i className={`bi ${icono} fs-4`} style={{ color: "var(--gris-600)" }}></i>
                <div>
                    <p className="mb-0 fw-semibold" style={{ fontSize: "0.9rem", color: "var(--gris-900)" }}>{titulo}</p>
                    <p className="mb-0" style={{ fontSize: "0.78rem", color: "var(--gris-600)" }}>{desc}</p>
                </div>
            </div>
        </button>
    );
}

export default ModalWhatsapp;
